import React, { useState } from 'react';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import AdminSidebar from './AdminSidebar';
import UserManagement from './UserManagement';
import CardKeyManagement from './CardKeyManagement';
import AdminAnalyticsDashboard from './admin/AdminAnalyticsDashboard';
import AnnouncementManagement from './AnnouncementManagement';
import RechargeConfig from './RechargeConfig';
import FeedbackManagement from './FeedbackManagement';
import AssistAiQuotaManagement from './AssistAiQuotaManagement';
import PackageManagement from '../pages/admin/PackageManagement';
import ArticleManagement from '../pages/admin/ArticleManagement';
import ReversePoolManagement from './ReversePoolManagement';
import FloatingWidgetConfig from './FloatingWidgetConfig';

const SIDEBAR_WIDTH = 220;

const MainContent = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #0a1929 0%, #001e3c 100%)',
}));

const AdminPanel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [activeTab, setActiveTab] = useState('stats');

  const renderContent = () => {
    switch (activeTab) {
      case 'users':
        return <UserManagement />;
      case 'cardkeys':
        return <CardKeyManagement />;
      case 'stats':
        return <AdminAnalyticsDashboard />;
      case 'announcements':
        return <AnnouncementManagement />;
      case 'recharge-config':
        return <RechargeConfig />;
      case 'feedback':
        return <FeedbackManagement />;
      case 'assist-ai-quota':
        return <AssistAiQuotaManagement />;
      case 'packages':
        return <PackageManagement />;
      case 'articles':
        return <ArticleManagement />;
      case 'reverse-pool':
        return <ReversePoolManagement />;
      case 'floating-widgets':
        return <FloatingWidgetConfig />;
      default:
        return <AdminAnalyticsDashboard />;
    }
  };

  return (
    <>
      <CssBaseline />
      <AdminSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <MainContent sx={{
        ml: isMobile ? 0 : `${SIDEBAR_WIDTH}px`,
        pt: isMobile ? '56px' : '64px',
        px: { xs: 1.5, sm: 2, md: 3 },
        py: { xs: 1.5, sm: 2, md: 3 },
      }}>
        {renderContent()}
      </MainContent>
    </>
  );
};

export default AdminPanel; 